// src/components/auth/CollaboratorRoute.jsx
// Renders:
//   - CollaboratorPortal  → if logged in AND role is 'collaborator' or 'admin'
//   - CollaboratorGate    → everyone else (guests, talents)
import { useAuth }          from '../../hooks/useAuth';
import { PageLoader }       from '../ui/Spinner';
import CollaboratorPortal   from '../../pages/CollaboratorPortal';
import CollaboratorGate     from '../../pages/CollaboratorGate';

export default function CollaboratorRoute() {
  const { user, profile, loading } = useAuth();

  // Still resolving Firebase auth — show spinner
  if (loading) return <PageLoader />;

  const isCollaborator =
    user &&
    profile &&
    (profile.role === 'collaborator' || profile.role === 'admin');

  return isCollaborator ? <CollaboratorPortal /> : <CollaboratorGate />;
}
